import { ComponentPropsWithoutRef } from "react";
import { BlockTextMedia as IBlockTextMedia } from "~/sanity/types";
import Grid from "~/components/globals/Grid";
import * as styles from "./SectionBlockTextMedia.css";
import { Heading } from "~/components/elements/Heading";
import PortableText from "~/components/portableText/PortableText";
// @ts-ignore
import ArrowOutward from "@material-design-icons/svg/filled/arrow_outward.svg?react";
import { ButtonLink } from "~/components/elements/ButtonLink";
import { IImage, Image } from "~/components/elements/Image";

export type SectionBlockTextMediaProps = ComponentPropsWithoutRef<"div"> & {
  data: IBlockTextMedia;
};

export const SectionBlockTextMedia = ({
  data,
  ...props
}: SectionBlockTextMediaProps) => {
  const { title, text, image, links } = data;
  console.log(data);
  return (
    <section>
      <Grid className={styles.wrapper} {...props}>
        <div className={styles.contentWrapper}>
          <div className={styles.textWrapper}>
            {title && (
              <Heading as="h2" size="h2">
                {title}
              </Heading>
            )}
            <PortableText blocks={text} />
          </div>
          {links && (
            <div className={styles.buttonContainer}>
              {links.map((link, index) => (
                <ButtonLink
                  isPrimary={true}
                  theme={index % 2 === 0 ? "dark" : "outlineDark"}
                  link={link}
                  key={index}
                  icons={
                    index % 2 === 0
                      ? { iconPrimary: <ArrowOutward /> }
                      : undefined
                  }
                >
                  {link.text}
                </ButtonLink>
              ))}
            </div>
          )}
        </div>
        <div className={styles.imageWrapper}>
          {image && (
            <div className={styles.imageContainer}>
              <Image className={styles.image} image={image} width={700} />
            </div>
          )}
        </div>
      </Grid>
    </section>
  );
};
